export const UIAnchorDirections = {
    top: 'up',
    bottom: 'down',
    right: 'right',
    left: 'left',
} as const;

export const UIAnchorPlacements = [
    'top-left',
    'top-middle',
    'top-right',
    'bottom-left',
    'bottom-middle',
    'bottom-right',
] as const;

export type UIAnchorPlacement = (typeof UIAnchorPlacements)[number];
export type UIAnchorDirection = keyof typeof UIAnchorDirections;
